import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const submitLead = async (payload) => {
  const { data } = await api.post("/leads", payload);
  return data;
};

export const fetchSpaces = async () => {
  const { data } = await api.get("/spaces");
  return data;
};
